"use client";

import Button from "./Button";
import { useLanguage } from "../../../shared/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <div className="flex items-center min-h-screen px-4 sm:px-6 lg:px-8 pt-16 sm:pt-0">
      <div className="max-w-4xl w-full animate-fade-in">
        <div className="space-y-4 sm:space-y-6 text-left pl-4 sm:pl-20 md:pl-24 lg:pl-28 pr-4 sm:pr-20 md:pr-24 lg:pr-28">
          {/* Main Heading - Responsive sizing */}
          <h1
            className="text-4xl xs:text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-serif font-bold text-white leading-tight"
            style={{
              textShadow:
                "2px 2px 8px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.6)",
            }}
          >
            {t("home.hero.title")}
          </h1>

          {/* Subtitle - Responsive sizing */}
          <p
            className="text-xl xs:text-2xl sm:text-2xl md:text-3xl text-gray-100 font-light"
            style={{
              textShadow:
                "2px 2px 6px rgba(0,0,0,0.8), 0 0 15px rgba(0,0,0,0.5)",
            }}
          >
            {t("home.hero.subtitle")}
          </p>

          {/* CTA Button */}
          <div className="pt-2 sm:pt-4">
            <Button href="#about">{t("home.hero.cta")}</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
